import React from 'react';
import { Contact } from '../components/Contact';
export function ContactPage() {
  return <div className="pt-24 min-h-screen" data-id="element-169">
      <Contact data-id="element-170" />
    </div>;
}